import { Route } from ".."
import { LoggingTable } from "../-components/logging-table"
import { Page } from "../../../../../-components/Page"

export function LoggingTablePage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <Page>
      <LoggingTable
        searchProps={{
          value: search,
          onChange: (value) =>
            navigate({
              search: { ...search, ...value },
              replace: true,
            }),
        }}
      />
    </Page>
  )
}
